import React from 'react'
import { Link } from 'react-router-dom'
import { useBreadcrumbs } from 'lib/core/hooks'
import { Container, DefaultBreadcrumbItem } from './styled'
import { JsonLd } from 'lib/shared'

interface Props {
  pageTitle?: string
  homePageName?: string
  disableHome?: boolean
  hasSkuBreadcrumb?: boolean
}

export const Breadcrumbs = ({
  pageTitle = '',
  homePageName= 'Home',
  disableHome,
  hasSkuBreadcrumb
}: Props) => {
  const { breadcrumb } = useBreadcrumbs({ pageTitle, homePageName, disableHome, hasSkuBreadcrumb })
  return (
    <Container>
      <div>
        <ul>
          <JsonLd.JsonLdBreadcrumbs breadcrumbItems={breadcrumb} />
          {breadcrumb.map((item, index) => (
            <DefaultBreadcrumbItem key={index}>
              {item.route ? (
                <Link to={item.route}>
                  {item.name}
                </Link>
              ) : item.name}
            </DefaultBreadcrumbItem>
          ))}
        </ul>
      </div>
    </Container>
  )
}
